<main class="mx-auto w-50 p-4">
  <form class="w-50 mx-auto" [formGroup]="loginForm" (ngSubmit)="this.login()">
    <h1 class="h3 mb-3">Bitte loggen Sie sich ein</h1>

    <div class="form-floating pb-1">
      <input id="email" name="email" type="email" class="form-control" formControlName="email">
      <label for="email">E-mail</label>
    </div>
    <div *ngIf="this.getFormControls()['email'].touched && this.getFormControls()['email'].invalid"
         class="alert alert-danger">
      <div *ngIf="this.getFormControls()['email'].errors?.['required']">Die E-Mail ist erforderlich.</div>
      <div *ngIf="this.getFormControls()['email'].errors?.['email']">Die E-Mail ist leider ungültig.</div>
    </div>

    <div class="form-floating">
      <input class="form-control" name="password" id="password" type="password" formControlName="password">
      <label class="form-check-label" for="password">Passwort</label>
    </div>
    <div *ngIf="this.getFormControls()['password'].touched && this.getFormControls()['password'].invalid"
         class="alert alert-danger">
      <div *ngIf="this.getFormControls()['password'].errors?.['required']">Das Password ist erforderlich.</div>
    </div>

    <button class="btn btn-primary w-100 py-2" type="submit">Anmelden</button>
  </form>
  <div style="width: 60%" *ngIf="this.invalidcredentials" class="alert alert-danger mx-auto mt-2">
    <div class="text-wrap">Die eingegebenen Zugangsdaten sind leider nicht korrekt</div>
  </div>
</main>
